/* cf-facets.js — soumission sans rechargement des facettes de collection.

   Amélioration pure (docs/06 §5). Sans ce fichier :
   - le formulaire reste un `GET` réel, le bouton « Apply » recharge la page
     filtrée ;
   - les pastilles de filtres actifs sont des liens ordinaires ;
   - le `<select>` de tri est soumis avec le formulaire.

   Le script masque lui-même le bouton « Apply » : il ne disparaît de l'écran
   que lorsque quelque chose le remplace vraiment.

   Une responsabilité, un fichier. */

class CfFacets extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form');
    this.sectionId = this.dataset.sectionId;
    if (!this.form || !this.sectionId) return;

    const apply = this.querySelector('[data-cf-facets-apply]');
    if (apply) apply.hidden = true;

    this.onChange = this.debounce(this.onChange.bind(this), 400);
    this.onClick = this.onClick.bind(this);
    this.onPopState = this.onPopState.bind(this);

    this.form.addEventListener('change', this.onChange);
    this.addEventListener('click', this.onClick);
    window.addEventListener('popstate', this.onPopState);
  }

  disconnectedCallback() {
    if (this.form) this.form.removeEventListener('change', this.onChange);
    this.removeEventListener('click', this.onClick);
    window.removeEventListener('popstate', this.onPopState);
  }

  debounce(fn, wait) {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => fn.apply(this, args), wait);
    };
  }

  onChange() {
    const params = new URLSearchParams(new FormData(this.form));
    // Un champ vide ne doit pas polluer l'URL.
    Array.from(params.keys()).forEach((key) => {
      if (!params.get(key)) params.delete(key);
    });
    this.render(this.form.action + '?' + params.toString());
  }

  onClick(event) {
    const link = event.target.closest('[data-cf-facet-link]');
    if (!link || event.metaKey || event.ctrlKey || event.shiftKey) return;
    event.preventDefault();
    this.render(link.href);
  }

  onPopState() {
    this.render(window.location.href, false);
  }

  async render(url, push) {
    const shouldPush = push !== false;
    const separator = url.indexOf('?') === -1 ? '?' : '&';
    this.setAttribute('aria-busy', 'true');

    try {
      const response = await fetch(url + separator + 'section_id=' + this.sectionId);
      if (!response.ok) throw new Error(response.statusText);

      const markup = await response.text();
      const parsed = new DOMParser().parseFromString(markup, 'text/html');

      this.swap(parsed, '#ProductGridContainer');
      this.swap(parsed, '#CfFacetsForm');
      this.swap(parsed, '.cf-facets__status');

      if (shouldPush) window.history.pushState({ url: url }, '', url);
    } catch (error) {
      // Sur échec réseau, on rend la main à la navigation normale plutôt que
      // de laisser un état faux à l'écran.
      window.location.href = url;
    } finally {
      this.removeAttribute('aria-busy');
    }
  }

  swap(source, selector) {
    const next = source.querySelector(selector);
    const current = document.querySelector(selector);
    if (next && current) current.innerHTML = next.innerHTML;
  }
}

if (!customElements.get('cf-facets')) {
  customElements.define('cf-facets', CfFacets);
}
